import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Icon from "components/AppIcon";
import { useLanguage } from "../../../LanguageContext";
import DeleteAreaModal from "./DeleteAreaModal";
import { useDispatch } from "react-redux";
import {
  deleteAreaService,
  getAllgovernoratesService,
} from "redux/services/general_service";
import { toast } from "react-toastify";
import EditAreaModal from "./EditAreaModal";
import ShippingSettingsModal from "./ShippingSettingsModal";
import { useTranslation } from "react-i18next";

const ShippingSettingsTable = ({
  clients,
  selectedClients,
  onSelectAll,
  onSelectClient,
  onDeleteClient,
  onEditClient,
  allSelected,
}) => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const dispatch = useDispatch();

  const [deleteModal, setDeleteModal] = useState({ isOpen: false, area: null });
  const [editModal, setEditModal] = useState({ isOpen: false, area: null });
  const [shippingModal, setShippingModal] = useState({
    isOpen: false,
    area: null,
  });

  const translations = {
    id: language === "ar" ? "الرقم" : "ID",
    name: language === "ar" ? "المحافظة" : "Name",
    cost_info: "التكلفة",
    expected_time: "الوقت المتوقع",
    actions: language === "ar" ? "الإجراءات" : "Actions",
    selectAll: language === "ar" ? "تحديد الكل" : "Select All",
  };

  const handleDeleteAreaClick = (area) =>
    setDeleteModal({ isOpen: true, area });

  const handleConfirmDelete = (areaId) => {
    dispatch(deleteAreaService(areaId)).then((response) => {
      if (response.payload?.status === 200) {
        toast.success("تم الحذف بنجاح");
        dispatch(getAllgovernoratesService());
        setDeleteModal({ isOpen: false, area: null });
      }
    });
  };

  return (
    <div className="overflow-hidden">
      {/* ================= Desktop Table ================= */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-center">{translations.id}</th>
              <th className="px-4 py-3 text-center">{translations.name}</th>
              <th className="px-4 py-3 text-center">
                {translations.cost_info}
              </th>
              <th className="px-4 py-3 text-center">
                {translations.expected_time}
              </th>
              <th className="px-4 py-3 text-center">{translations.actions}</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200 bg-white">
            {clients?.map((client) => (
              <tr key={client.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 text-center">{client.id}</td>
                <td className="px-4 py-3 text-center">
                  {client?.province?.translations?.ar?.name}
                </td>
                <td className="px-4 py-3 text-center">{client?.cost_info}</td>
                <td className="px-4 py-3 text-center">
                  {client?.expected_time}
                </td>
                <td className="px-4 py-3 text-center">
                  <div className="flex justify-center space-x-2">
                    <button
                      onClick={() => onEditClient(client)}
                      className="text-green-600"
                    >
                      <Icon name="Edit" size={16} />
                    </button>
                    <button
                      onClick={() => onDeleteClient(client.id)}
                      className="text-red-600"
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ================= Mobile Cards ================= */}
      <div className="lg:hidden divide-y divide-gray-200">
        {clients?.map((client) => (
          <div key={client.id} className="p-4 space-y-3">
            <div className="flex items-start space-x-3">
        

              <div className="flex-1 space-y-1">
                <div className="flex justify-between">
                  <span className="font-medium text-gray-900">
                    {client?.province?.translations?.ar?.name}
                  </span>
                  <span className="text-xs text-gray-500">#{client.id}</span>
                </div>

                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div>
                    <span className="text-gray-500">
                      {translations.cost_info}
                    </span>
                    <div className="font-medium">{client?.cost_info}</div>
                  </div>

                  <div>
                    <span className="text-gray-500">
                      {translations.expected_time}
                    </span>
                    <div className="font-medium">{client?.expected_time}</div>
                  </div>
                </div>

                <div className="flex justify-end space-x-3 pt-2">
                  <button
                    onClick={() => onEditClient(client)}
                    className="text-green-600 text-sm"
                  >
                    تعديل
                  </button>
                  <button
                    onClick={() => onDeleteClient(client.id)}
                    className="text-red-600 text-sm"
                  >
                    حذف
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ================= Modals ================= */}
      <DeleteAreaModal
        isOpen={deleteModal.isOpen}
        onClose={() => setDeleteModal({ isOpen: false, area: null })}
        onConfirm={handleConfirmDelete}
        area={deleteModal.area}
        language={language}
      />

      <EditAreaModal
        isOpen={editModal.isOpen}
        onClose={() => setEditModal({ isOpen: false, area: null })}
        area={editModal.area}
        language={language}
      />

      <ShippingSettingsModal
        isOpen={shippingModal.isOpen}
        onClose={() => setShippingModal({ isOpen: false, area: null })}
        area={shippingModal.area}
      />
    </div>
  );
};

export default ShippingSettingsTable;
